import React from "react";
import { Row, Col, Popover } from "antd";
import { FormattedMessage } from "react-intl";
import RadioButtonItem from "../../../components/forms/RadioButtonItem";
import Surface from "../../../components/layouts/Surface";
import FormHeader from "../../../components/forms/FormHeader";
import Spacer from "../../../components/layouts/Spacer";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import FreeTextAndSelectItem from "../../../components/forms/FreeTextAndSelectItem";
import SchedulingPopover from "./SchedulingPopover";
import moment from "moment";

const General = (props) => {
  const { enabled, patient, date } = props;
  const content = (
    <div>
      <SchedulingPopover
        startDate={moment(date).startOf("day").format()}
        endDate={moment(date).endOf("day").format()}
        patient={patient}
      />
    </div>
  );
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <Surface>
        <FormHeader
          title={<FormattedMessage id="app.house_visits.general" />}
        />
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <RadioButtonItem
                  name="care_giver_was_presented"
                  category="house_visits"
                  trueFalse={true}
                  disabled={!enabled}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <Popover
                  placement="top"
                  title={null}
                  trigger="hover"
                  destroyTooltipOnHide
                  content={content}
                >
                  <div>
                    <RadioButtonItem
                      name="report.time_mathed_planning"
                      category="house_visits"
                      trueFalse={true}
                      disabled={!enabled}
                    />
                  </div>
                </Popover>
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <RadioButtonItem
                  name="report.first_visit"
                  category="house_visits"
                  trueFalse={true}
                  disabled={!enabled}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <RadioButtonItem
                  name="report.phone_visit"
                  category="house_visits"
                  trueFalse={true}
                  disabled={!enabled}
                />
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <FreeTextAndSelectItem
                  name="report.care_giver_absence_reason"
                  category="house_visits"
                  params={{
                    name: "meta/system_tables/house_visits/care_giver_absence_reason",
                  }}
                  disabled={!enabled}
                />
              </div>
              <Spacer horizontal={true} />
              <div style={{ flex: 1 }}>
                <FreeTextAndSelectItem
                  name="report.other_participants"
                  category="house_visits"
                  params={{
                    name: "meta/system_tables/house_visits/other_participants",
                  }}
                  disabled={!enabled}
                />
              </div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </Surface>
    </div>
  );
};

export default General;
